<form [formGroup]="form" (ngSubmit)="accept()">
    <h1 mat-dialog-title>Rendiciones</h1>
    <div mat-dialog-content>
        <mat-spinner *ngIf="loading"></mat-spinner>
        <mat-form-field *ngIf="!loading" class="full-width">
            <mat-select placeholder="Tipo de rendición" formControlName="billingReportType">
                <mat-option *ngFor="let billingReportType of billingReportTypeFilters" [value]="billingReportType"> {{ billingReportType.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="f.billingReportType.errors && f.billingReportType.errors.required">
                Ingrese el tipo de rendición
            </mat-error>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div *ngIf="!loading" class="pull-right">
            <button mat-button type="submit">Aceptar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>